<router-outlet>
</router-outlet>